export const mapDataForBackend = (group) => ({
  name: group.name,
  devices: group.devices?.map(item => ({
    id: item.value,
  })) || [],
});
